import { useMemo } from "react"
import { PendientesSubtotales } from "../Pago.type"

export function useSort(data: any[], pendientesSubtotales?: PendientesSubtotales) {
    const getCategoryList = (products: any[]) => {
        const keys: string[] = products.map((a) => a?.almacen_articulo?.articulo?.categoria_articulo?.nombre || "")

        return [...new Set(keys)].map((key) => {
            let total = 0

            products.forEach((a) => {
                if (a?.almacen_articulo?.articulo?.categoria_articulo?.nombre === key) {
                    total += Number(a?.costo_con_iva || 0)
                }
            })
            return {
                label: `${key}`,
                value: total,
            }
        })
    }

    const sort = useMemo(() => {
        if (data[0]?.orden_id) {
            const orders = data.map((i) => ({
                label: i?.orden || "",
                value: i?.total_con_iva || 0,
            }))

            const categoryList = getCategoryList(data.map((a) => a?.detalles_orden).flat(1))

            return { orders, categoryList }
        }

        const estancias = data.map((i) => ({
            label: i?.detalle || "",
            value: i?.total || 0,
        }))

        if (pendientesSubtotales) {
            const s = pendientesSubtotales
            const categoryList = [
                s.subtotal_hospedaje > 0
                    ? { label: `Estancia (${s.dias_estancia} ${s.dias_estancia > 1 ? "noches" : "noche"})`, value: s.subtotal_hospedaje }
                    : null,
                s.subtotal_hospedajes_extra > 0
                    ? { label: `Hospedajes extras (${s.cantidad_hospedajes_extra} ${s.cantidad_hospedajes_extra > 1 ? "noches" : "noche"})`, value: s.subtotal_hospedajes_extra }
                    : null,
                s.subtotal_personas_extra > 0
                    ? { label: `Personas extras (${s.cantidad_personas_extra})`, value: s.subtotal_personas_extra }
                    : null,
                s.subtotal_horas_extra > 0
                    ? { label: `Horas extras (${s.cantidad_horas_extra})`, value: s.subtotal_horas_extra }
                    : null,
            ].filter((item): item is { label: string; value: number } => item !== null)

            return { orders: estancias, categoryList }
        }

        return { orders: estancias, categoryList: [] }
    }, [data, pendientesSubtotales])

    return sort
}